import { useEventListener } from './useEventListener.js';
export function useDocumentEventListener(type, listener, options) {
    if (typeof document !== 'undefined') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEventListener(document, type, listener, options);
    }
}
//# sourceMappingURL=useDocumentEventListener.js.map